@let sidebar = productViewLayout.sidebar;

<page-sidebar [class]="{'size-guide': (sidebar === 'size-guide'), 'icms-open': client.isCms}"
              [backArrow]="!client.isS && sidebar !== 'size-guide'"
              [closeButton]="sidebar === 'how-to-measure' || sidebar === 'size-guide'"
              [(isOpen)]="productViewLayout.isSidebarOpen"
              (isOpenChange)="handleIsOpenChange()"
              (closeRequest)="handleCloseRequest()">
    @if (shouldRenderSidebarContent('reviews')) {
    <product-reviews [class.ng-hide]="sidebar !== 'reviews'"
                     [product]="productViewLayout.parent().familyIds"
                     [productName]="product().data?.name"
                     [productData]="productViewLayout.parent" />
    }
    @if (shouldRenderSidebarContent('details')) {
    <product-layout-details-general [class.ng-hide]="sidebar !== 'details'"
                                    [productViewLayout]="productViewLayout"
                                    [content]="content()" />
    }
    @if (shouldRenderSidebarContent('dimensions')) {
    <product-layout-details-general-dimensions [class.ng-hide]="sidebar !== 'dimensions'"
                                               [productViewLayout]="productViewLayout"
                                               [content]="content()" />
    }
    @if (shouldRenderSidebarContent('gift-boxing')) {
    <product-layout-gift-boxing [class.ng-hide]="sidebar !== 'gift-boxing'"
                                [content]="content()" />
    }
    @if (shouldRenderSidebarContent('delivery')) {
    <product-delivery-price [class.ng-hide]="sidebar !== 'delivery'"
                            [productId]="product().id"
                            [content]="{
                                returnNote: content().returnNote,
                                returnLink: content().returnLink,
                                returnLinkText: content().returnLinkText
                            }" />
    }
    @if (shouldRenderSidebarContent('klarna')) {
    <basket-klarna-content-block class="w-12"
                                 [class.ng-hide]="sidebar !== 'klarna'" />
    }

    @if (shouldRenderSidebarContent('stock-notification')) {
    <bloomreach-stock-notification class="w-12"
                                   [class.ng-hide]="sidebar !== 'stock-notification'"
                                   [model]="product()" />
    }
    @if (productViewLayout.sizeGuideVariant && shouldRenderSidebarContent('size-guide')) {
    <product-layout-sidebar-size-guide [class.ng-hide]="sidebar !== 'size-guide'"
                                       [variant]="productViewLayout.sizeGuideVariant"
                                       [productViewLayout]="productViewLayout" />
    }
    @if (shouldRenderSidebarContent('how-to-measure')) {
    <product-layout-sidebar-how-to-measure [class.ng-hide]="sidebar !== 'how-to-measure'"
                                           [variant]="productViewLayout.sizeGuideVariant" />
    }
</page-sidebar>